<template>

    <v-layout row justify-center v-if="dialog">
      <v-dialog v-model="dialog" persistent max-width="290">
        <template v-slot:activator="{ on }" >
          <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>
        <v-card v-if="ShowReport">
          <v-card-title class="headline">{{ displayid }} ist nicht in Xcelera verfügbar</v-card-title>
          <v-card-text>Bitte bestätigen.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="onReloadMyoidOK(displayid_id, messdurchgang)">Ja</v-btn>
            <v-btn color="blue darken-1" flat @click="onReloadMyoidCancel(displayid_id, messdurchgang)">Nein</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="ShowDone">
          <v-card-title class="headline">{{ displayid }} Wurde nachgemessen</v-card-title>
          <v-card-text>Bitte bestätigen.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="onReloadMyoidMeasured(displayid_id, messdurchgang)">Ja</v-btn>
            <v-btn color="blue darken-1" flat @click="onReloadMyoidCancel(displayid_id, messdurchgang)">Nein</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>




    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-toolbar color="blue darken-3" dark>
           
  
            <v-toolbar-title>Echonachmessung Studienärzte (Studienarzt)</v-toolbar-title>
  

          </v-toolbar>
  
            <v-layout justify-center>
                  <v-progress-circular
                  
                        indeterminate
                      color="primary"
                      v-if="loading"
                    ></v-progress-circular> 
          </v-layout>

          <v-list two-line v-if="!loading">
            <template v-for="(myoid) in myoids">
            
  
              <v-divider :key="myoid.id"></v-divider>
  
               <v-list-tile
                :key="0"
                avatar
              >
                <v-list-tile-avatar>
                  <v-icon  :key="null" @click="onClickReport(myoid.myoid, myoid.messdurchgang)">report_problem</v-icon>
               </v-list-tile-avatar>

  
                <v-list-tile-content>
                  <v-list-tile-title v-html="myoid.myoid"></v-list-tile-title>
                  <v-list-tile-sub-title>Messdurchgang: {{myoid.messdurchgang}}</v-list-tile-sub-title>
                </v-list-tile-content>
                  <v-icon  :key="null" @click="onClickDone(myoid.myoid, myoid.messdurchgang)">done</v-icon>
               <v-list-tile-avatar>
                  
               </v-list-tile-avatar>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { router } from '@/router';
import { authenticationService } from '@/services';
import { myoidService } from '@/services';
import transfereHub from '@/hubs/transfere-hub'
import { store } from '@/store';
import { mapMutations } from "vuex";


export default {
    data () {
        return {
            user: authenticationService.currentUserValue,
            myoids: [],
            ShowReport: false,
            ShowDone: false,
            dialog: false,
            displayid: '',
            displayid_id: null,
            messdurchgang: '',
            loading: true,
        };
    },

    methods: {
      ...mapMutations(["setSnackbar"]),

            async onReloadMyoidOK(id, messdurchgang) {
                this.displayid = id;
                this.displayid_id = id;
                this.messdurchgang = messdurchgang;
                this.ShowReport = false;
                this.ShowDone = false;
                this.dialog = false;
                this.loading = true;
                await myoidService.SetMyoidNotLoaded(id, this.messdurchgang).then(antwort => this.antwort = antwort);
                this.loading = false;
                this.setSnackbar("MYOID als NA markiert",  "success", 5);
            },


            async onReloadMyoidMeasured(id, messdurchgang) {
                this.displayid = id;
                this.displayid_id = id;
                this.messdurchgang = messdurchgang;
                this.ShowReport = false;
                this.ShowDone = false;
                this.dialog = false;
                this.loading = true;
                await myoidService.SetMyoidNotMeasruedByStudyDoc(id, this.messdurchgang).then(antwort => this.antwort = antwort);
                this.loading = false;
                this.setSnackbar("MYOID als NA markiert",  "success", 5);
            },

            async onReloadMyoidCancel(id, messdurchgang) {
                this.displayid = id;
                this.displayid_id = id;
                this.ShowReport = false;
                this.ShowDone = false;
                this.dialog = false;
                this.setSnackbar("Abbruch",  "success", 5);
            },

            async onClickReport(id, messdurchgang) {
                this.displayid = id;
                this.displayid_id = id;
                this.messdurchgang = messdurchgang;
                this.ShowReport = true;
                this.dialog = true;
            },

            async onClickDone(id, messdurchgang) {
                this.displayid = id;
                this.displayid_id = id;
                this.messdurchgang = messdurchgang;
                this.ShowDone = true;
                this.dialog = true;
            },

            async onMyoidChanged ({myoidid}) {
              this.loading=true;
              await myoidService.GetMYOIDforuser("studydoc").then(myoids => this.myoids = myoids);
              this.loading = false;
              this.setSnackbar("MYOID-Liste neu geladen",  "success", 5);
              

            },

          
    },



    async created () {
        await myoidService.GetMYOIDforuser("studydoc").then(myoids => this.myoids = myoids);   
        this.loading=false;
        this.$transfereHub.$on('MyoidIDChanged', this.onMyoidChanged)
    },


    beforeDestroy () {
       this.$transfereHub.$off('MyoidIDChanged', this.onMyoidChanged)
    },
};
</script>